export interface Exec {
  role: string;
  sub?: string;
  name: string;
  photo: string;
  bio: string;
  inside: boolean;
}

export const EXECS: Exec[] = [
  {
    role: 'Representative Director, President & CEO',
    name: 'Daisuke Hirano',
    photo: 'assets/leadership/hirano.jpg',
    bio:
      "Founding-family successor leading Mystar Engineering's long-term thesis: keeping Japan's technical-service industry alive through the Technical Services Federation. Previously at McKinsey & Company; before that at Mizuho Securities (bond markets, M&A advisory). Waseda University; MA Anthropology, University of Hawai'i; MBA, Columbia Business School.",
    inside: true,
  },
  {
    role: 'Senior Managing Director',
    sub: 'Head of Facility Business · Head of Corporate Planning',
    name: 'Shinichiro Oda',
    photo: 'assets/leadership/oda.jpg',
    bio:
      'Leads M&A and post-acquisition organisation design across the federation. Joined Mystar Engineering in 2019. Previously Industrial Bank of Japan (now Mizuho); Associate Partner at McKinsey (manufacturing & financial institutions); Director at Digital Arts. University of Tokyo (Economics); MBA, London Business School.',
    inside: true,
  },
  {
    role: 'Director',
    sub: 'Head of Administration',
    name: 'Takayuki Kokon',
    photo: 'assets/leadership/kokon.jpg',
    bio:
      'Owns the back-office foundations — finance, HR, general affairs and IT — that let federation companies operate cleanly. Joined 2021. Previously A.T. Kearney; President of Mabuchi Motor\'s Dalian production subsidiary; corporate planning lead. University of Tokyo (Social Psychology).',
    inside: true,
  },
  {
    role: 'Director',
    sub: 'Head of Mechatronics Business',
    name: 'Hironobu Fukutomi',
    photo: 'assets/leadership/fukutomi.jpg',
    bio:
      "Heads the group's core Mechatronics business, including engineer-supply infrastructure and reform of the manufacturing-services platform. Joined August 2023. Previously JVCKenwood (R&D, supply-chain build-outs) and Misumi (FA new-business launch and division leadership). Kobe University; MSc, NAIST.",
    inside: true,
  },
  {
    role: 'Outside Director',
    name: 'Naoki Otani',
    photo: 'assets/leadership/otani.jpg',
    bio:
      'Joined Mystar Engineering in 2015. Lawyer by training (Nishimura & Asahi); private-equity investing at Unison Capital; executive officer / CIO at Revamp; currently Executive Officer, Head of Buyout Investment at Japan Post Bank Asset Management Co., Ltd. Chuo University Law.',
    inside: false,
  },
  {
    role: 'Outside Director',
    name: 'Shinichi Ueyama',
    photo: 'assets/leadership/ueyama.jpg',
    bio:
      'Career across the Ministry of Transport (now MLIT), McKinsey Japan (Senior Partner), Georgetown and Keio University. Currently Emeritus Professor at Keio, Vice President at ZEN University; outside director at StarFlyer and Heiwado; policy advisor to Osaka, Kyoto, Aichi and Kitakyushu.',
    inside: false,
  },
  {
    role: 'Outside Audit & Supervisory Board Member',
    name: 'Taiji Yoshikawa',
    photo: 'assets/leadership/yoshikawa.jpg',
    bio:
      'Joined Mystar Engineering in June 2019. Founding member of Kennedix; later Head of Administration and Director & CFO. Led the company\'s IPO and subsequent IR; arranged J-REITs and private real-estate funds. Toyama National College of Technology; Hosei University Law.',
    inside: false,
  },
];
